module.exports = __webpack_public_path__ + "static/media/LineWeight.eed814f3.svg";